import { ApplicationConfig, LOCALE_ID, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { routes } from './app.routes';
import { ProjectRouteReuseStrategy } from './utils/project-route-reuse.strategy';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authHeaderInterceptor, errorHandlingInterceptor } from './interceptors/request.interceptor';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { environment } from '../environments/environment';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { provideEchartsCore } from 'ngx-echarts';
import { TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { TranslationHttpLoader } from './services/language/translation-http.loader';
import { LanguageService } from './services/language/language.service';
import { AuthService } from './services/auth/auth.service';
import { EnumLanguage } from './enums/language.enum';
import {
  BankOutline,
  SettingOutline,
  FileDoneOutline,
  PlusCircleOutline,
  UserOutline,
  ProfileOutline,
  TeamOutline,
  SafetyCertificateOutline,
  LogoutOutline,
  ExportOutline,
  RightOutline,
  MenuOutline,
  CloseOutline,
  DownOutline,
  FolderOutline,
  CheckOutline,
  PlusOutline,
  BellOutline,
  BarChartOutline,
  AreaChartOutline,
  RobotOutline,
} from '@ant-design/icons-angular/icons';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    { provide: RouteReuseStrategy, useClass: ProjectRouteReuseStrategy },
    provideHttpClient(withFetch(), withInterceptors([errorHandlingInterceptor, authHeaderInterceptor])),
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    provideTranslateService({
      defaultLanguage: EnumLanguage.SPANISH,
      loader: { provide: TranslateLoader, useClass: TranslationHttpLoader },
    }),
    provideAppInitializer(() => inject(LanguageService).initialize()),
    provideAppInitializer(() => inject(AuthService).listenTokenChanges()),
    { provide: LOCALE_ID, useFactory: () => inject(LanguageService).getLocaleId() },
    { provide: NZ_I18N, useFactory: () => inject(LanguageService).getNzLocale() },
    provideAnimations(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    provideEchartsCore({ echarts: () => import('echarts') }),
    provideNzIcons([
      BankOutline,
      SettingOutline,
      FileDoneOutline,
      PlusCircleOutline,
      UserOutline,
      ProfileOutline,
      TeamOutline,
      SafetyCertificateOutline,
      LogoutOutline,
      ExportOutline,
      RightOutline,
      MenuOutline,
      CloseOutline,
      DownOutline,
      FolderOutline,
      CheckOutline,
      PlusOutline,
      BellOutline,
      BarChartOutline,
      AreaChartOutline,
      RobotOutline,
    ]),
  ],
};
